export default __webpack_public_path__ + "static/media/businessman-with-tie.6d5cb81f.png";